require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.for-each");

var _defineProperty = require("/codebuild/output/src3666327469/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/codebuild/output/src3666327469/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

var _slicedToArray = require("/codebuild/output/src3666327469/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/codebuild/output/src3666327469/src/entle-socialjustice/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var tap = require('lodash/tap');

var map = require('lodash/map');

var toPairs = require('lodash/toPairs');

var fromPairs = require('lodash/fromPairs');

var mergeWith = require('lodash/mergeWith');

var flatMap = require('lodash/flatMap');

var isEmpty = require('lodash/isEmpty');

var isArray = require('lodash/isArray');

var isFunction = require('lodash/isFunction');

var isUndefined = require('lodash/isUndefined');

var isPlainObject = require('lodash/isPlainObject');

var defaultOptions = require('./defaultOptions');

var svgToDataUri = require('mini-svg-data-uri');

var traverse = require('traverse');

function merge() {
  function mergeCustomizer(objValue, srcValue, key, obj, src, stack) {
    if (isPlainObject(srcValue)) {
      return mergeWith(objValue, srcValue, mergeCustomizer);
    }

    return Object.keys(src).includes(key) // Convert undefined to null otherwise lodash won't replace the key
    // PostCSS still omits properties with a null value so it behaves
    // the same as undefined.
    ? srcValue === undefined ? null : srcValue : objValue;
  }

  for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
    options[_key] = arguments[_key];
  }

  return mergeWith.apply(void 0, [{}].concat(options, [mergeCustomizer]));
}

function flattenOptions(options) {
  return merge.apply(void 0, _toConsumableArray(flatMap(toPairs(options), function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        keys = _ref2[0],
        value = _ref2[1];

    return fromPairs(keys.split(', ').map(function (key) {
      return [key, value];
    }));
  })));
}

function resolveOptions(userOptions) {
  return merge({
    "default": defaultOptions
  }, fromPairs(map(userOptions, function (value, key) {
    return [key, flattenOptions(value)];
  })));
}

function replaceIconDeclarations(component, replace) {
  return traverse(component).map(function (value) {
    if (!isPlainObject(value)) {
      return;
    }

    if (Object.keys(value).includes('iconColor') || Object.keys(value).includes('icon')) {
      var iconColor = value.iconColor,
          icon = value.icon,
          rest = _objectWithoutProperties(value, ["iconColor", "icon"]);

      this.update(merge(replace({
        icon: icon,
        iconColor: iconColor
      }), rest));
    }
  });
}

module.exports = function (_ref3) {
  var addUtilities = _ref3.addUtilities,
      addComponents = _ref3.addComponents,
      theme = _ref3.theme,
      postcss = _ref3.postcss;

  function addInput(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(_defineProperty({}, ".form-input".concat(modifier), options));
  }

  function addTextarea(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(_defineProperty({}, ".form-textarea".concat(modifier), options));
  }

  function addMultiselect(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(_defineProperty({}, ".form-multiselect".concat(modifier), options));
  }

  function addSelect(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(replaceIconDeclarations(_defineProperty({}, ".form-select".concat(modifier), merge(_objectSpread({
      '&::-ms-expand': {
        color: options.iconColor
      }
    }, isUndefined(options.paddingLeft) ? {} : {
      '@media print and (-ms-high-contrast: active), print and (-ms-high-contrast: none)': {
        paddingRight: options.paddingLeft // Fix padding for print in IE

      }
    }), options)), function (_ref4) {
      var _ref4$icon = _ref4.icon,
          icon = _ref4$icon === void 0 ? options.icon : _ref4$icon,
          _ref4$iconColor = _ref4.iconColor,
          iconColor = _ref4$iconColor === void 0 ? options.iconColor : _ref4$iconColor;
      return {
        backgroundImage: "url(\"".concat(svgToDataUri(isFunction(icon) ? icon(iconColor) : icon), "\")")
      };
    }));
  }

  function addCheckbox(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(replaceIconDeclarations(_defineProperty({}, ".form-checkbox".concat(modifier), merge(_objectSpread({}, isUndefined(options.borderWidth) ? {} : {
      '&::-ms-check': {
        '@media not print': {
          borderWidth: options.borderWidth
        }
      }
    }), options)), function (_ref5) {
      var _ref5$icon = _ref5.icon,
          icon = _ref5$icon === void 0 ? options.icon : _ref5$icon,
          _ref5$iconColor = _ref5.iconColor,
          iconColor = _ref5$iconColor === void 0 ? options.iconColor : _ref5$iconColor;
      return {
        '&:checked': {
          backgroundImage: "url(\"".concat(svgToDataUri(isFunction(icon) ? icon(iconColor) : icon), "\")")
        }
      };
    }));
  }

  function addRadio(options) {
    var modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (isEmpty(options)) {
      return;
    }

    addComponents(replaceIconDeclarations(_defineProperty({}, ".form-radio".concat(modifier), merge(_objectSpread({}, isUndefined(options.borderWidth) ? {} : {
      '&::-ms-check': {
        '@media not print': {
          borderWidth: options.borderWidth
        }
      }
    }), options)), function (_ref6) {
      var _ref6$icon = _ref6.icon,
          icon = _ref6$icon === void 0 ? options.icon : _ref6$icon,
          _ref6$iconColor = _ref6.iconColor,
          iconColor = _ref6$iconColor === void 0 ? options.iconColor : _ref6$iconColor;
      return {
        '&:checked': {
          backgroundImage: "url(\"".concat(svgToDataUri(isFunction(icon) ? icon(iconColor) : icon), "\")")
        }
      };
    }));
  }

  function registerComponents() {
    var options = resolveOptions(theme('customForms'));
    addInput(options["default"].input);
    addTextarea(options["default"].textarea);
    addMultiselect(options["default"].multiselect);
    addSelect(options["default"].select);
    addCheckbox(options["default"].checkbox);
    addRadio(options["default"].radio);
    Object.keys(function (_ref7) {
      var _default = _ref7["default"],
          rest = _objectWithoutProperties(_ref7, ["default"]);

      return rest;
    }(options)).forEach(function (key) {
      var modifier = "-".concat(key);
      addInput(options[key].input || {}, modifier);
      addTextarea(options[key].textarea || {}, modifier);
      addMultiselect(options[key].multiselect || {}, modifier);
      addSelect(options[key].select || {}, modifier);
      addCheckbox(options[key].checkbox || {}, modifier);
      addRadio(options[key].radio || {}, modifier);
    });
  }

  registerComponents();
};